var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('user-items', {
    staticClass: "user-items--icon-text",
    attrs: {
      "icon": "",
      "text": ""
    }
  }, [_vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }